import '../css/app.css';

import modernizrSource from './modernizr.js?raw';
import jquerySource from './jquery.js?raw';
import parsleySource from './parsley.min.js?raw';
import select2Source from './select2.js?raw';
import formSource from './form.js?raw';
import scriptSource from './script.js?raw';

const runBrowserScript = (source, name) => {
    const browserSource = `
        var module = undefined;
        var exports = undefined;
        var define = undefined;
        var require = undefined;
        ${source}
        //# sourceURL=${name}
    `;

    new Function('window', 'document', browserSource)(window, document);
};

[
    [modernizrSource, 'modernizr.js'],
    [jquerySource, 'jquery.js'],
    [parsleySource, 'parsley.min.js'],
    [select2Source, 'select2.js'],
    [formSource, 'form.js'],
    [scriptSource, 'script.js'],
].forEach(([source, name]) => runBrowserScript(source, name));
